import { Component, computed, input } from '@angular/core';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { getInitialsFromString } from 'app/foundation/util/text.utils';
import { getBackgroundColorHue } from 'app/foundation/util/color.utils';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'jhi-profile-picture',
    templateUrl: './profile-picture.component.html',
    styleUrls: ['./profile-picture.component.scss'],
    imports: [RouterLink, CommonModule, FontAwesomeModule],
})
export class ProfilePictureComponent {
    imageSizeInRem = input<string>('2.15');
    fontSizeInRem = input<string>('0.9');
    authorName = input<string | undefined>(undefined);
    authorId = input<number | undefined>(undefined);
    imageUrl = input<string | undefined>(undefined);
    imageClass = input<string>('');
    defaultPictureClass = input<string>('');
    imageId = input<string>('');
    defaultPictureId = input<string>('');
    isEditable = input<boolean>(false);
    isGray = input<boolean>(false);
    isBoxShadow = input<boolean>(false);
    imageBackgroundColor = input<string | undefined>(undefined);

    readonly userProfilePictureInitials = computed(() => (this.authorName() === undefined ? 'NA' : getInitialsFromString(this.authorName()!)));
    readonly profilePictureBackgroundColor = computed(() => getBackgroundColorHue(this.authorId()?.toString() ?? this.authorName()));
    readonly imageSize = computed(() => this.imageSizeInRem().replaceAll('rem', '') + 'rem');
    readonly fontSize = computed(() => this.fontSizeInRem().replaceAll('rem', '') + 'rem');

    protected readonly faCog = faCog;
}
